import React from "react";

const FlexBlock = {
  label: "Flex",
  fields: {
    direction: {
      type: "radio",
      label: "Direction",
      options: [
        { label: "Row", value: "row" },
        { label: "Column", value: "column" },
      ],
    },
    justifyContent: {
      type: "radio",
      label: "Justify Content",
      options: [
        { label: "Start", value: "flex-start" },
        { label: "Center", value: "center" },
        { label: "End", value: "flex-end" },
        { label: "Space Between", value: "space-between" },
      ],
    },
    alignItems: {
      type: "radio",
      label: "Align Items",
      options: [
        { label: "Start", value: "flex-start" },
        { label: "Center", value: "center" },
        { label: "End", value: "flex-end" },
        { label: "Stretch", value: "stretch" },
      ],
    },
    gap: {
      type: "number",
      label: "Gap (px)",
      min: 0,
    },
    wrap: {
      type: "radio",
      label: "Wrap",
      options: [
        { label: "Wrap", value: "wrap" },
        { label: "No Wrap", value: "nowrap" },
      ],
    },
    items: {
      type: "slot",
    },
  },
  defaultProps: {
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: 16,
    wrap: "wrap",
    items: [],
  },
  render: ({ direction, justifyContent, alignItems, gap, wrap, items: Items, puck }) => {
    return (
      <Items
        style={{
          display: "flex",
          flexDirection: direction || "row",
          justifyContent: justifyContent || "flex-start",
          alignItems: alignItems || "center",
          gap: `${gap ?? 16}px`,
          flexWrap: wrap || "wrap",
          minHeight: puck?.isEditing ? "64px" : undefined,
        }}
      />
    );
  },
};

export default FlexBlock;
